/**
 * HUMANSTARSapp
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const StorageModule = {
    News: 'news',
    Feedback: 'feedback',
    Knowledgebase: 'knowledgebase',
    Communities: 'communities',
    Workflow: 'workflow',
    Tv: 'tv'
} as const;
export type StorageModule = typeof StorageModule[keyof typeof StorageModule];
